import { render, staticRenderFns } from "./Mvg.vue?vue&type=template&id=5fb72bcc&scoped=true&"
import script from "./Mvg.vue?vue&type=script&lang=js&"
export * from "./Mvg.vue?vue&type=script&lang=js&"
import style0 from "./Mvg.vue?vue&type=style&index=0&id=5fb72bcc&scoped=true&lang=scss&"
import style1 from "./Mvg.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Mvg.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb72bcc",
  null
  
)

export default component.exports